import React, { useEffect, useState } from "react";
import TitleComponent from "../../components/title/Title";
import OrdersTable from "./OrdersTable";
import axiosInstance from "../../axiosInstance";
import LoadingComponent from "../../components/loading/Loading";
import PlainButton from "../../components/button/PlainButton";

function OrdersMain() {
  const [state, setState] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const checkState = async () => {
    try {
      const response = await axiosInstance.get("/payments/setup/vendors");
      if (response.data.data.connected_account_id) {
        setState(true);
        setLoading(false);
        console.log(
          "State fetched successfully:",
          response.data.data.stripe_account_id
        );
      } else {
        setState(false);
        setLoading(false);

        console.log("No state found");
      }
    } catch (error) {
      setLoading(false);

      setState(false);
      console.error("Error fetching state:", error);
    }
  };

  useEffect(() => {
    checkState();
  }, []);

 
  const SetupStripe = () => {
    setLoading(true);
    const handleSetupLink = async () => {
      const res = await axiosInstance.post("/payments/setup/vendors");
      if (res.data) {
        setLoading(false);

        console.log("Redirecting to Stripe setup link:", res.data.data);
        window.open(res.data.data.onboarding_url, "_blank");
      }


      else {
        setLoading(false);
      }
    };
    return (
      <div>
        <h2 className="text-center">Setup Stripe Account</h2>
        <p className="text-center">
          Please set up your Stripe account to manage orders.
        </p>
        <div className="stripe-setup-button">
          <PlainButton onClick={handleSetupLink} text="Setup Stripe" />
        </div>
      </div>
    );
  };

  return (
    <div className="body--container">
      <TitleComponent title="Orders" />




      {!loading && state !== true ? <SetupStripe /> : <OrdersTable />}
    </div>
  );
}

export default OrdersMain;
